<template>
  <div class="main">
    <b-tabs>
      <b-tab title="Leaves" active>
        <b-card>
          <b-card-body>
            <b-row>
              <b-col md="12" class="d-flex justify-content-end">
                <b-modal
                  id="modal-add-leave-request"
                  ok-only
                  ok-title="Add"
                  centered
                  size="lg"
                  title="New Leave Request"
                  :hide-footer="true"
                  ref="addNewLeaveRequest"
                >
                  <NewLeaveRequest
                    @LeaveRequestAdded="closeAddModal"
                    :employeeId="selectedEmployeeId"
                  />
                </b-modal>
                <b-button variant="primary" v-b-modal.modal-add-leave-request>
                  <feather-icon icon="PlusIcon" class="mr-50" />
                  New Leave Request
                </b-button>
                <b-button
                  variant="outline-primary"
                  class="ml-2"
                  @click="exportToExcel"
                >
                  <feather-icon icon="DownloadIcon" class="mr-50" />
                  Export to Excel
                </b-button>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" md="2" sm="1" class="my-1">
                <b-form-group class="mb-0">
                  <label class="d-inline-block text-sm-left">Per page</label>
                  <b-form-select
                    id="perPageSelect"
                    v-model="perPage"
                    size="sm"
                    :options="pageOptions"
                  />
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <!-- <b-col cols="12" md="4" sm="4" class="my-1">
                <b-form-group
                  label="Sort"
                
                  label-size="sm"
                  label-for="sortBySelect"
                  class="mb-0"
                >
                  <b-input-group size="sm">
                    <b-form-select
                      id="sortBySelect"
                      v-model="sortBy"
                      :options="sortOptions"
                      class="w-75"
                    >
                      <template v-slot:first>
                        <option value="">-- none --</option>
                      </template>
</b-form-select>
<b-form-select v-model="sortDesc" size="sm" :disabled="!sortBy" class="w-25">
  <option :value="false">Asc</option>
  <option :value="true">Desc</option>
</b-form-select>
</b-input-group>
</b-form-group>
</b-col> -->
              <b-col cols="12" md="4" sm="4" class="my-1">
                <b-form-group
                  label="Filter"
                  label-size="sm"
                  label-for="filterInput"
                >
                  <b-input-group size="sm">
                    <b-form-input
                      id="filterInput"
                      v-model="filter"
                      type="search"
                      placeholder="Type to Search"
                    />
                    <!-- <b-input-group-append>
                      <b-button :disabled="!filter" @click="filter = ''">
                        Clear
                      </b-button>
                    </b-input-group-append> -->
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <b-table
                  striped
                  hover
                  responsive
                  :per-page="perPage"
                  :current-page="currentPage"
                  :items="employee_items"
                  :fields="my_fields"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :sort-direction="sortDirection"
                  :filter="filter"
                  :filter-function="customFilter"
                  @filtered="onFiltered"
                >
                  <template #cell(startDate)="data">
                    {{ formatDate(data.item.startDate) }}
                  </template>

                  <template #cell(managerId)="data">
                    {{ getEmployee(data.item.managerId) }}
                  </template>

                  <template #cell(approvedDate)="data">
                    {{ formatDate(data.item.approvedDate) }}
                  </template>

                  <template #cell(leaveTypeID)="data">
                    {{ getLeaveType(data.item.leaveTypeID) }}
                  </template>
                  <template #cell(returnDate)="data">
                    {{ formatDate(data.item.returnDate) }}
                  </template>

                  <!-- <template #cell(date_approved)="data">
                    {{ formatDate(data.item.date_approved) }}
                  </template> -->

                  <template #cell(status)="data">
                    <b-badge :variant="statusVariants[data.item.status]">
                      {{ data.item.status }}
                    </b-badge>
                  </template>

                  <template v-slot:cell(actions)="data">
                    <b-dropdown
                      variant="link"
                      toggle-class="p-0"
                      no-caret
                      class="m-1"
                    >
                      <template #button-content>
                        <feather-icon
                          icon="MoreVerticalIcon"
                          size="16"
                          class="align-middle text-body"
                        />
                      </template>
                      <!-- <b-dropdown-item
                        :disabled="data.item.status !== 'PENDING'"
                        @click="editMyLeaveRequest(data.item)"
                      >
                        <feather-icon icon="EditIcon" />
                        <span class="align-middle ml-50">Edit</span>
                      </b-dropdown-item> -->
                      <b-dropdown-item
                        :disabled="
                          !IsAdmin() || data.item.status == 'CANCELLED'
                        "
                        @click="
                          cancelAction('CANCELLED', data.item.leaveRequestId)
                        "
                      >
                        <feather-icon icon="TrashIcon" />
                        <span class="align-middle ml-50">Cancel</span>
                      </b-dropdown-item>
                    </b-dropdown>
                  </template>
                </b-table>

                <!-- <b-modal
                  id="modal-edit-leave-request"
                  ok-only
                  ok-title="Edit"
                  centered
                  size="lg"
                  title="Edit Leave Request"
                  :hide-footer="true"
                  ref="editLeaveRequest"
                >
                  <EditLeaveRequest @refresh="refreshData" />
                </b-modal> -->

                <b-modal
                  ref="modalMydetails"
                  id="modal-edit-leaves"
                  title="Edit Leave Request"
                  hide-footer
                  centered
                  size="lg"
                >
                  <validation-observer
                    ref="editLeaveRequestForm"
                    v-slot="{ invalid, validate }"
                  >
                    <b-form @submit.prevent="updateLeaveRequest">
                      <b-col md="6" v-if="IsAdmin()">
                        <b-form-group label="Employee*" label-for="employee">
                          <validation-provider
                            v-slot="{ errors }"
                            name="employee"
                            vid="employee"
                            rules="required"
                          >
                            <b-form-select
                              v-model="viewLeaves.employeeId"
                              :options="formattedEmployeeOptions"
                              value-field="id"
                              text-field="fullName"
                              :state="errors.length > 0 ? false : null"
                              required
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-form-group>
                      </b-col>

                      <!-- <b-col md="6">
                        <b-form-group label="Employee" label-for="employee">
                          <validation-provider name="employee" rules="required" v-slot="{ errors }">
                            <b-form-input id="employee" :value="getEmployee(viewLeaves.employeeId)" disabled />
                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-form-group>
                      </b-col> -->
                      <b-col md="6">
                        <b-form-group label="Leave Type" label-for="leaveType">
                          <validation-provider
                            name="leaveType"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <b-form-select
                              id="leaveType"
                              v-model="viewLeaves.leaveTypeID"
                              :options="leavetypes"
                              value-field="leaveTypeId"
                              text-field="title"
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-form-group>
                      </b-col>
                      <b-col md="6">
                        <b-form-group label="Start Date" label-for="startDate">
                          <validation-provider
                            rules="required"
                            #default="{ errors }"
                            name="startDate"
                            vid="startDate"
                          >
                            <b-form-datepicker
                              id="startDate"
                              placeholder="Start Date"
                              :state="errors.length > 0 ? false : null"
                              v-model="viewLeaves.startDate"
                              :max="today"
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-form-group>
                      </b-col>
                      <b-col md="6">
                        <b-form-group label="End Date" label-for="returnDate">
                          <validation-provider
                            rules="required|afterStartDate:@startDate"
                            v-slot="{ errors }"
                            name="returnDate"
                            vid="returnDate"
                          >
                            <b-form-datepicker
                              id="returnDate"
                              placeholder="End Date"
                              :state="errors.length > 0 ? false : null"
                              v-model="viewLeaves.returnDate"
                              :max="today"
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-form-group>
                      </b-col>
                      <b-col md="6">
                        <b-form-group
                          label="Leave Duration Type"
                          label-for="leaveDurationType"
                        >
                          <validation-provider
                            name="leaveDurationType"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <b-form-select
                              v-model="viewLeaves.leaveDurationType"
                              :options="leaveDurationTypeOptions"
                              required
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-form-group>
                      </b-col>
                      <b-col md="6">
                        <b-form-group
                          label="Upload File"
                          label-for="upload_file"
                        >
                          <b-form-file
                            v-model="viewLeaves.file"
                            placeholder="Choose a file or drop it here..."
                            drop-placeholder="Drop file here..."
                          />
                        </b-form-group>
                      </b-col>
                      <b-col md="12">
                        <b-form-group label="Notes" label-for="notes">
                          <validation-provider
                            name="notes"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <b-form-textarea
                              id="notes"
                              v-model="viewLeaves.notes"
                              placeholder="notes"
                              rows="1"
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-form-group>
                      </b-col>

                      <b-col md="6">
                        <b-form-group
                          label="Approving Manager*"
                          label-for="managerId"
                        >
                          <validation-provider
                            v-slot="{ errors }"
                            name="managerId"
                            vid="managerId"
                            rules="required"
                          >
                            <b-form-select
                              v-model="viewLeaves.managerId"
                              :options="formattedEmployeeOptions"
                              value-field="id"
                              text-field="fullName"
                              :state="errors.length > 0 ? false : null"
                              required
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-form-group>
                      </b-col>

                      <!-- submit and reset -->
                      <b-col md="12" class="d-flex justify-content-between">
                        <b-button
                          type="button"
                          variant="primary"
                          :disabled="invalid"
                          @click="updateLeaveRequest()"
                        >
                          Save Changes
                        </b-button>
                      </b-col>
                    </b-form>
                  </validation-observer>
                </b-modal>

                <div class="d-flex justify-content-center mb-1">
                  <div
                    class="d-flex justify-content-center mb-1"
                    v-if="loading"
                  >
                    <b-spinner
                      variant="success"
                      label="Spinning"
                      style="width: 3rem; height: 3rem"
                    ></b-spinner>
                  </div>
                </div>
              </b-col>

              <b-col cols="12">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows"
                  :per-page="perPage"
                  align="center"
                  size="sm"
                  class="my-0"
                />
                <b-form-group>
                  Showing
                  {{ totalRows > 0 ? perPage * (currentPage - 1) + 1 : 0 }}
                  to
                  {{
                    totalRows > 0
                      ? Math.min(perPage * currentPage, totalRows)
                      : 0
                  }}
                  of
                  {{ totalRows > 0 ? totalRows : 0 }}
                  entries
                </b-form-group>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-tab>
      <b-tab title="Subordinate Leaves">
        <b-card>
          <b-card-body>
            <b-row>
              <b-col md="12" class="d-flex justify-content-end">
                <!-- <b-modal
                  id="modal-add-leave-request"
                  ok-only
                  ok-title="Add"
                  centered
                  size="lg"
                  title="New Leave Request"
                  :hide-footer="true"
                  ref="newLeaveRequest"
                >
                  <NewLeaveRequest @refresh="refreshData" />
                </b-modal> -->
                <!-- <b-button variant="primary" v-b-modal.modal-add-leave-request>
                  <feather-icon icon="PlusIcon" class="mr-50" />
                  New Leave Request
                </b-button> -->
              </b-col>
            </b-row>
            <b-row>
              <b-col md="2" sm="4" class="my-1">
                <b-form-group class="mb-0">
                  <label class="d-inline-block text-sm-left mr-50"
                    >Per page</label
                  >
                  <b-form-select
                    id="perPageSelect"
                    v-model="perPage1"
                    size="sm"
                    :options="pageOptions1"
                    class="w-50"
                  />
                </b-form-group>
              </b-col>
              <!-- <b-col md="4" sm="8" class="my-1">
                <b-form-group
                  label="Sort"
                  label-cols-sm="3"
                  label-align-sm="right"
                  label-size="sm"
                  label-for="sortBySelect"
                  class="mb-0"
                >
                  <b-input-group size="sm">
                    <b-form-select
                      id="sortBySelect"
                      v-model="sortBy"
                      :options="sortOptions"
                      class="w-75"
                    >
                      <template v-slot:first>
                        <option value="">-- none --</option>
                      </template>
                    </b-form-select>
                    <b-form-select
                      v-model="sortDesc"
                      size="sm"
                      :disabled="!sortBy"
                      class="w-25"
                    >
                      <option :value="false">Asc</option>
                      <option :value="true">Desc</option>
                    </b-form-select>
                  </b-input-group>
                </b-form-group>
              </b-col> -->
              <b-col md="6" class="my-1">
                <b-form-group
                  label="Filter"
                  label-cols-sm="3"
                  label-align-sm="right"
                  label-size="sm"
                  label-for="filterInput"
                  class="mb-0"
                >
                  <b-input-group size="sm">
                    <b-form-input
                      id="filterInput"
                      v-model="filter"
                      type="search"
                      placeholder="Type to Search"
                    />
                    <b-input-group-append>
                      <b-button :disabled="!filter" @click="filter = ''">
                        Clear
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <b-col cols="12">
                <b-table
                  striped
                  hover
                  responsive
                  :per-page="perPage1"
                  :current-page="currentPage1"
                  :items="itemsEmp"
                  :fields="subordinates_fields"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :sort-direction="sortDirection"
                  :filter="filter"
                  :filter-function="customFilterSubordinates"
                  @filtered="onFiltered"
                >
                  <template #cell(employeeId)="data">
                    {{ getEmployee(data.item.employeeId) }}
                  </template>

                  <template #cell(leaveTypeID)="data">
                    {{ getLeaveType(data.item.leaveTypeID) }}
                  </template>

                  <template #cell(startDate)="data">
                    {{ formatDate(data.item.startDate) }}
                  </template>
                  <template #cell(managerId)="data">
                    {{ getEmployee(data.item.managerId) }}
                  </template>

                  <template #cell(returnDate)="data">
                    {{ formatDate(data.item.returnDate) }}
                  </template>

                  <template #cell(approvedDate)="data">
                    {{ formatDate(data.item.approvedDate) }}
                  </template>

                  <template #cell(status)="data">
                    <b-badge :variant="statusVariants[data.item.status]">
                      {{ data.item.status }}
                    </b-badge>
                  </template>

                  <template v-slot:cell(actions)="data">
                    <b-dropdown
                      variant="link"
                      toggle-class="p-0"
                      no-caret
                      class="m-1"
                    >
                      <template #button-content>
                        <feather-icon
                          icon="MoreVerticalIcon"
                          size="16"
                          class="align-middle text-body"
                        />
                      </template>
                      <!-- <b-dropdown-item
                        :disabled="data.item.status !== 'PENDING'"
                        @click="editLeaveRequest(data.item)"
                      >
                        <feather-icon icon="EditIcon" />
                        <span class="align-middle ml-50">Edit</span>
                      </b-dropdown-item> -->
                      <b-dropdown-item
                        :disabled="
                          !IsAdmin() || data.item.status == 'CANCELLED'
                        "
                        @click="
                          cancelAction('CANCELLED', data.item.leaveRequestId)
                        "
                      >
                        <feather-icon icon="TrashIcon" />
                        <span class="align-middle ml-50">Cancel</span>
                      </b-dropdown-item>
                    </b-dropdown>
                  </template>
                </b-table>
                <!-- <b-modal
                  id="modal-edit-leave-request"
                  ok-only
                  ok-title="Edit"
                  centered
                  size="lg"
                  title="Edit Leave Request"
                  :hide-footer="true"
                  ref="editLeaveRequest"
                >
                  <EditLeaveRequest @refresh="refreshData" />
                </b-modal> -->
              </b-col>

              <b-modal
                ref="modalSubsdetails"
                id="modal-edit-subs"
                title="Edit Subordinate Leaves"
                hide-footer
                centered
                size="lg"
              >
                <validation-observer
                  ref="editLeaveRequestForm"
                  v-slot="{ invalid, validate }"
                >
                  <b-form @submit.prevent="updateLeaveRequest">
                    <b-col md="6" v-if="IsAdmin()">
                      <b-form-group label="Employee*" label-for="employee">
                        <validation-provider
                          v-slot="{ errors }"
                          name="employee"
                          vid="employeeId"
                          rules="required"
                        >
                          <b-form-select
                            v-model="viewSubs.employeeId"
                            :options="formattedEmployeeOptions"
                            value-field="id"
                            text-field="fullName"
                            :state="errors.length > 0 ? false : null"
                            required
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>

                    <b-col md="6">
                      <b-form-group label="Leave Type" label-for="leaveType">
                        <validation-provider
                          name="leaveType"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <b-form-select
                            id="leaveType"
                            v-model="viewSubs.leaveTypeID"
                            :options="leavetypes"
                            value-field="leaveTypeId"
                            text-field="title"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>
                    <b-col md="6">
                      <b-form-group label="Start Date" label-for="startDate">
                        <validation-provider
                          rules="required"
                          #default="{ errors }"
                          name="startDate"
                          vid="startDate"
                        >
                          <b-form-datepicker
                            id="startDate"
                            placeholder="Start Date"
                            :state="errors.length > 0 ? false : null"
                            v-model="viewSubs.startDate"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>
                    <b-col md="6">
                      <b-form-group label="End Date" label-for="returnDate">
                        <validation-provider
                          rules="required"
                          #default="{ errors }"
                          name="returnDate"
                          vid="returnDate"
                        >
                          <b-form-datepicker
                            id="returnDate"
                            placeholder="End Date"
                            :state="errors.length > 0 ? false : null"
                            v-model="viewSubs.returnDate"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>
                    <b-col md="6">
                      <b-form-group
                        label="Leave Duration Type"
                        label-for="leaveDurationType"
                      >
                        <validation-provider
                          name="leaveDurationType"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <b-form-select
                            v-model="viewSubs.leaveDurationType"
                            :options="leaveDurationTypeOptions"
                            required
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group></b-col
                    >
                    <b-col md="6">
                      <b-form-group label="Upload File" label-for="upload_file">
                        <b-form-file
                          v-model="viewSubs.file"
                          placeholder="Choose a file or drop it here..."
                          drop-placeholder="Drop file here..."
                        />
                      </b-form-group>
                    </b-col>
                    <b-col md="12">
                      <b-form-group label="Notes" label-for="notes">
                        <validation-provider
                          name="notes"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <b-form-textarea
                            id="notes"
                            v-model="viewSubs.notes"
                            placeholder="notes"
                            rows="1"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>
                    <!-- <b-col md="6">
                      <b-form-group label="Approving Manager*" label-for="approving_manager">
                        <validation-provider v-slot="{ errors }" name="approving_manager" vid="approving_manager"
                          rules="required">
                          <b-form-select v-model="viewSubs.managerId" :options="formattedEmployeeOptions"
                            value-field="id" text-field="fullName" :state="errors.length > 0 ? false : null" required />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col> -->

                    <!-- submit and reset -->
                    <b-col md="12" class="d-flex justify-content-between">
                      <b-button
                        type="button"
                        @click="updateLeaveRequest(false)"
                        variant="primary"
                        :disabled="invalid"
                      >
                        Save Changes
                      </b-button>
                    </b-col>
                  </b-form>
                </validation-observer>
              </b-modal>

              <b-col cols="12">
                <b-pagination
                  v-model="currentPage1"
                  :total-rows="totalRows1"
                  :per-page="perPage1"
                  align="center"
                  size="sm"
                  class="my-0"
                />
                <b-form-group>
                  Showing
                  {{ totalRows1 > 0 ? perPage1 * (currentPage1 - 1) + 1 : 0 }}
                  to
                  {{
                    totalRows1 > 0
                      ? Math.min(perPage1 * currentPage1, totalRows1)
                      : 0
                  }}
                  of
                  {{ totalRows1 > 0 ? totalRows1 : 0 }}
                  entries
                </b-form-group>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import {
  BTable,
  BAvatar,
  BBadge,
  BRow,
  BCol,
  BFormGroup,
  BSpinner,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BCard,
  BDropdown,
  BLink,
  BDropdownItem,
  BTab,
  BTabs,
  BFormTextarea,
  BFormFile,
  BFormDatepicker,
  BCardBody,
  BToast,
  BForm,
} from "bootstrap-vue";
import { mapGetters, mapActions } from "vuex";
import { customLoader, customError, customSwal } from "@/libs/customFn";
import { ValidationObserver, ValidationProvider, extend } from "vee-validate";
import NewLeaveRequest from "./NewLeaveRequest.vue";
//import EditLeaveRequest from "./EditLeaveRequest.vue";
import Swal from "sweetalert2";
import { required } from "vee-validate/dist/rules";
import { IsAdmin } from "@/@core/utils/validations/permissionCheck";

extend("required", {
  ...required,
  message: "This field is required",
});

extend("afterStartDate", {
  params: ["startDate"],
  validate(value, { startDate }) {
    return new Date(value) > new Date(startDate);
  },
  message: "Return Date must be after Start Date.",
});

export default {
  components: {
    BCard,
    BToast,
    BCardBody,
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BSpinner,
    BDropdown,
    BLink,
    BDropdownItem,
    BTab,
    BTabs,
    BFormTextarea,
    BFormDatepicker,
    NewLeaveRequest,
    //EditLeaveRequest,
    BFormFile,
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      today: new Date(),
      perPage: 5,
      pageOptions: [3, 5, 10],
      totalRows: 1,
      currentPage: 1,
      perPage1: 5,
      pageOptions1: [3, 5, 10],
      totalRows1: 1,
      currentPage1: 1,
      filter: null,
      sortDesc: null,
      sortBy: null,
      sortDirection: null,
      employeeOptions: [],
      filterOn: [],
      my_fields: [],
      itemsEmp: [],
      selectedEmployeeId: null,
      statusVariants: {
        APPROVED: "success",
        PENDING: "warning",
        REJECTED: "danger",
      },

      leaveDurationTypeOptions: [
        { value: "FullDay", text: "Full Day" },
        { value: "HalfDay", text: "Half Day" },
      ],
      subordinates_fields: [
        { key: "employeeId", label: "Employee Name", sortable: true },
        { key: "leaveTypeID", label: "Leave Type", sortable: true },
        { key: "startDate", label: "Start Date", sortable: true },
        { key: "returnDate", label: "End Date", sortable: true },
        {
          key: "leaveDurationType",
          label: "Leave Duration Type",
          sortable: true,
        },
        { key: "notes", label: "Notes", sortable: true },
        {
          key: "managerId",
          label: "Approving Manager",
          sortable: true,
        },
        { key: "days", label: "Days", sortable: true },
        { key: "approvedDate", label: "Date Approved", sortable: true },
        { key: "status", label: "Status", sortable: true },
        { key: "actions", label: "Actions" },
      ],
      status: [
        {
          APPROVED: "APPROVED",
          PENDING: "PENDING",
          REJECTED: "REJECTED",
        },
        {
          APPROVED: "success",
          PENDING: "warning",
          REJECTED: "danger",
        },
      ],
      viewSubs: {
        employeeId: null,
        leaveTypeID: null,
        startDate: null,
        returnDate: null,
        leaveDurationType: null,
        file: null,
        notes: null,
        managerId: null,
      },

      viewLeaves: {
        employeeId: null,
        leaveTypeID: null,
        startDate: null,
        returnDate: null,
        leaveDurationType: null,
        file: null,
        notes: null,
        managerId: null,
      },
    };
  },
  computed: {
    ...mapGetters("leaverequestModule", {
      leaverequests: "leaverequests",
      employee_items: "employee",
      subordinates_items: "subordinate",
      loading: "loading",
    }),
    ...mapGetters("employeeModule", {
      employeeList: "employees",
      loading: "loading",
    }),

    ...mapGetters("leavetypeModule", {
      leavetypes: "leavetypes",
      loading: "loading",
    }),
    formattedEmployeeOptions() {
      const userData = JSON.parse(localStorage.getItem("userData"));
      return this.employeeList
        .filter((x) => IsAdmin() || x.refId != userData.id)
        .map((employee) => {
          if (employee.id != this.employeeId) {
            return {
              ...employee,
              fullName: `${employee.firstName} ${employee.lastName}`,
            };
          } else {
            return {
              ...employee,
              fullName: `${employee.firstName} ${employee.lastName}`,
            };
          }
        });
    },

    filteredData() {
      if (this.filter === "") {
        return this.employee_items;
      }
      return this.employee_items.filter((item) => {
        return item.leaveTypeID
          .toLowerCase()
          .includes(this.filter.toLowerCase());
      });
    },
  },
  methods: {
    ...mapActions("leaverequestModule", [
      "getLeaveRequestListAction",
      "getLeaveRequestEmployeeAction",
      "getLeaveRequestSubordinatesAction",
      "putLeaveRequestApprovalAction",
      "updateLeaveRequestAction",
    ]),
    customFilter(item, filter) {
      if (!filter) return true;
      const lowerFilter = filter.toLowerCase();

      const fieldsToSearch = [
        this.getLeaveType(item.leaveTypeID), // Leave Type
        this.formatDate(item.startDate), // Start Date
        this.formatDate(item.returnDate), // End Date
        item.leaveDurationType, // Leave Duration Type
        item.notes || "", // Notes
        this.getEmployee(item.managerId), // Approving Manager
        item.days?.toString(), // Days
        this.formatDate(item.approvedDate), // Date Approved
        item.status, // Status
      ];

      return fieldsToSearch.some((field) =>
        (field || "").toLowerCase().includes(lowerFilter)
      );
    },

    customFilterSubordinates(item, filter) {
  if (!filter) return true;
  const lowerFilter = filter.toLowerCase();

  const fieldsToSearch = [
    this.getEmployee(item.employeeId), // Employee Name
    this.getLeaveType(item.leaveTypeID), // Leave Type
    this.formatDate(item.startDate), // Start Date
    this.formatDate(item.returnDate), // End Date
    item.leaveDurationType || "", // Duration Type
    item.notes || "", // Notes
    this.getEmployee(item.managerId), // Manager
    item.days?.toString() || "", // Days
    this.formatDate(item.approvedDate), // Approved Date
    item.status, // Status
  ];

  return fieldsToSearch.some((field) =>
    (field || "").toLowerCase().includes(lowerFilter)
  );
},

    ...mapActions("leavetypeModule", ["getLeaveTypeListAction"]),

    ...mapActions("employeeModule", ["getEmployeeListAction"]),
    formatDate(date) {
      if (date != null) {
        const options = { year: "numeric", month: "short", day: "numeric" };
        return new Date(date).toLocaleDateString("en-US", options);
      } else {
        return "-";
      }
    },
    showAddLeaveRequestModal() {
      this.$refs.modalAddLeaveRequest.show();
    },
    async closeAddModal() {
      this.$refs.addNewLeaveRequest.hide();
      let loader = customLoader("Please wait while saving the leave request");
      await this.getLeaveRequestEmployeeAction().then(() => {
        this.totalRows = this.employee_items.length;
      });

      if (IsAdmin()) {
        this.getLeaveRequestListAction().then(() => {
          this.itemsEmp = this.leaverequests;
          this.totalRows1 = this.itemsEmp.length;
        });
      } else {
        this.getLeaveRequestSubordinatesAction().then(() => {
          this.itemsEmp = this.subordinates_items;
          this.totalRows1 = this.itemsEmp.length;
        });
      }

      loader.close();
    },

    getEmployee(id) {
      const employee = this.employeeList.find((s) => s.id === id);
      return employee ? employee.firstName + " " + employee.lastName : "-";
    },

    getNote(note) {
      if (note == null) {
        return "-";
      }
    },

    getLeaveType(id) {
      const leave = this.leavetypes.find((s) => s.leaveTypeId === id);
      return leave ? leave.title : "-";
    },

    addNewLeaveRequest(leaverequest) {
      this.currentDepartment = leaverequest;
    },
    // async addNewLeaveRequest() {
    //   this.loading = true;
    //   const loader = Swal.fire({
    //     title: 'Processing...',
    //     text: 'Please wait while the Leave Request is being added',
    //     allowOutsideClick: () => !Swal.isLoading(),
    //     showConfirmButton: false,
    //     showCancelButton: false,
    //     buttonsStyling: false,
    //     willOpen: () => {
    //       Swal.showLoading();
    //     }
    //   });

    //   try {
    //     await this.addLeaveRequestAction(this.newLeaveRequest);
    //     loader.close();
    //     this.$bvModal.hide('modal-add-gps-device');
    //     this.success('Leave Request added successfully.');
    //     this.loading = false;
    //     this.getLeaveRequestListAction();
    //     this.resetForm();
    //   } catch (error) {
    //     loader.close();
    //     this.error(error.response.data);
    //     this.loading = false;
    //     this.getLeaveRequestListAction();
    //   } finally {
    //     this.loading = false;
    //   }
    // },

    showViewLeaveRequestModal(item) {
      this.viewLeaveRequest = { ...item };
      this.$refs.modalViewLeaveRequest.show();
    },
    showEditLeaveRequestModal(item) {
      this.editLeaveRequest = { ...item };
      this.$refs.modalEditLeaveRequest.show();
      this.getLeaveRequestEmployeeAction();
    },

    updateLeaveRequest(myLeaves = true) {
      let loader = customLoader("Please wait while updating the leave request");
      if (myLeaves) {
        const index = this.leaverequests.findIndex(
          (doc) => doc.id === this.viewLeaves.leaveRequestId
        );

        let docForm = new FormData();
        docForm.append("id", this.viewLeaves.leaveRequestId);
        docForm.append("employeeId", this.viewLeaves.employeeId);
        docForm.append("leaveTypeID", this.viewLeaves.leaveTypeID);
        docForm.append("startDate", this.viewLeaves.startDate);
        docForm.append("returnDate", this.viewLeaves.returnDate);
        docForm.append("Status", "PENDING");
        docForm.append("Notes", this.viewLeaves.notes);
        docForm.append("leaveDurationType", this.viewLeaves.leaveDurationType);
        docForm.append("managerId", this.viewLeaves.managerId);
        docForm.append("attachmentType", 0);
        docForm.append("file", this.viewLeaves.file);

        this.editDocLoader = customLoader(
          "Please wait while leave request is being updated"
        );

        this.updateLeaveRequestAction(docForm)
          .then((response) => {
            if (response.success) {
              this.$bvModal.hide("modal-edit-leaves");
              customSwal(
                "Leave request has been updated",
                "Success",
                "success"
              );

              this.getLeaveRequestEmployeeAction().then(() => {
                this.totalRows = this.employee_items.length;
              });
              if (IsAdmin()) {
                this.getLeaveRequestListAction().then(() => {
                  this.itemsEmp = this.leaverequests;
                  this.totalRows1 = this.itemsEmp.length;
                });
              } else {
                this.getLeaveRequestSubordinatesAction().then(() => {
                  this.itemsEmp = this.subordinates_items;
                  this.totalRows1 = this.itemsEmp.length;
                });
              }
            } else {
              customError(response, "Error");
            }
            this.editDocLoader.close();
          })
          .catch((error) => {
            this.editDocLoader.close();
            customError(error.response.data, "Error");
          });

        if (index !== -1) {
          this.leaverequests.splice(index, 1, { ...this.viewLeaves });
          //this.$refs.modalMydetails.hide();
          this.$bvModal.hide("modal-edit-leaves");
          this.resetForm();
        }
      } else {
        const index = this.leaverequests.findIndex(
          (doc) => doc.id === this.viewSubs.leaveRequestId
        );

        let docForm = new FormData();
        docForm.append("id", this.viewSubs.leaveRequestId);
        docForm.append("employeeId", this.viewSubs.employeeId);
        docForm.append("leaveTypeID", this.viewSubs.leaveTypeID);
        docForm.append("startDate", this.viewSubs.startDate);
        docForm.append("returnDate", this.viewSubs.returnDate);
        docForm.append("Status", "PENDING");
        docForm.append("notes", this.viewSubs.notes);
        docForm.append("leaveDurationType", this.viewSubs.leaveDurationType);
        docForm.append("managerId", this.viewSubs.managerId);
        docForm.append("attachmentType", 0);
        docForm.append("file", this.viewSubs.file);
        this.editDocLoader = customLoader(
          "Please wait while leave request is being updated"
        );
        this.updateLeaveRequestAction(docForm)
          .then((response) => {
            if (response.success) {
              customSwal(
                "Leave request has been updated",
                "Success",
                "success"
              );
              this.$bvModal.hide("modal-edit-subs");
              // this.getLeaveRequestEmployeeAction();
              // this.getLeaveRequestSubordinatesAction();
              this.getLeaveRequestEmployeeAction().then(() => {
                this.totalRows = this.employee_items.length;
              });
              if (IsAdmin()) {
                this.getLeaveRequestListAction().then(() => {
                  this.itemsEmp = this.leaverequests;
                  this.totalRows1 = this.itemsEmp.length;
                });
              } else {
                this.getLeaveRequestSubordinatesAction().then(() => {
                  this.itemsEmp = this.subordinates_items;
                  this.totalRows1 = this.itemsEmp.length;
                });
              }
            } else {
              customError(response, "Error");
              this.getLeaveRequestEmployeeAction();
              this.getLeaveRequestSubordinatesAction();
            }
            this.editDocLoader.close();
          })
          .catch((error) => {
            this.editDocLoader.close();
            customError(error.response.data, "Error");
            this.getLeaveRequestEmployeeAction();
            this.getLeaveRequestSubordinatesAction();
          });

        if (index !== -1) {
          this.leaverequests.splice(index, 1, { ...this.viewLeaves });
          this.$bvModal.hide("modal-edit-subs");
          this.$refs.modalSubsdetails.hide();
          this.resetForm();
          this.getLeaveRequestEmployeeAction();
          this.getLeaveRequestSubordinatesAction();
        }
      }
      loader.close();
    },

    // async updateLeaveRequest() {
    //   this.loading = true;
    //   const loader = Swal.fire({
    //     title: "Processing...",
    //     text: "Please wait while the Leave Request is being updated",
    //     allowOutsideClick: () => !Swal.isLoading(),
    //     showConfirmButton: false,
    //     showCancelButton: false,
    //     buttonsStyling: false,
    //     willOpen: () => {
    //       Swal.showLoading();
    //     },
    //   });

    //   try {
    //     await this.updateLeaveRequestAction(this.editLeaveRequest);
    //     loader.close();
    //     this.$bvModal.hide("modal-edit-gps-device");
    //     this.success("Leave Request updated successfully.");
    //     this.loading = false;
    //     this.resetForm();
    //     this.getLeaveRequestEmployeeAction();
    //   } catch (error) {
    //     loader.close();
    //     this.error(error.response.data);
    //     this.loading = false;
    //     this.getLeaveRequestEmployeeAction();
    //   } finally {
    //     this.getLeaveRequestEmployeeAction();
    //     this.loading = false;
    //   }
    // },
    async confirmDeleteLeaveRequest(gpsId) {
      const confirmation = await Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel!",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      });

      if (confirmation.isConfirmed) {
        this.deleteLeaveRequest(gpsId);
      } else if (confirmation.dismiss === Swal.DismissReason.cancel) {
        Swal.fire({
          title: "Cancelled",
          text: "Your Leave Request is safe :)",
          icon: "error",
          customClass: {
            confirmButton: "btn btn-success",
          },
        });
      }
    },

    async deleteLeaveRequest(gpsId) {
      const loader = Swal.fire({
        title: "Processing...",
        text: "Please wait while the Leave Request is being deleted",
        allowOutsideClick: () => !Swal.isLoading(),
        showConfirmButton: false,
        showCancelButton: false,
        buttonsStyling: false,
        willOpen: () => {
          Swal.showLoading();
        },
      });

      try {
        await this.removeLeaveRequestAction(gpsId);
        loader.close();
        Swal.fire({
          title: "Deleted!",
          text: "The Leave Request has been deleted.",
          icon: "success",
          customClass: {
            confirmButton: "btn btn-success",
          },
        });
        this.resetForm();
        this.getLeaveRequestEmployeeAction();
      } catch (error) {
        loader.close();
        this.error(error.response.data);
        this.getLeaveRequestEmployeeAction();
      }
    },

    editLeaveRequest(item) {
      this.viewSubs = { ...item };
      // console.log(
      //   "fuck",
      //   this.viewSubs,
      //   this.employeeOptions.filter((x) => x.value == this.viewSubs.managerId)
      // );
      this.$refs.modalSubsdetails.show();
    },

    editMyLeaveRequest(item) {
      this.viewLeaves = { ...item };
      this.$refs.modalMydetails.show();
    },

    async cancelAction(status, item) {
      console.log("item", item);
      try {
        // confirm update
        const result = await this.$swal({
          title: "Are you sure?",
          text: "You will not be able to revert your changes!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, update status!",
          cancelButtonText: "Cancel",
          customClass: {
            confirmButton: "btn btn-primary",
            cancelButton: "btn btn-outline-danger ml-1",
          },
          buttonsStyling: false,
        });

        if (result.isConfirmed) {
          let loader = customLoader(
            "Please wait while cancelling the leave request"
          );
          const payload = {
            id: item,
            status: status,
          };

          try {
            await this.putLeaveRequestApprovalAction(payload).then(() => {
              this.success();

              this.getLeaveRequestEmployeeAction().then(() => {
                this.totalRows = this.employee_items.length;
              });

              this.getLeaveRequestSubordinatesAction().then(() => {
                this.itemsEmp = this.subordinates_items;
                this.totalRows1 = this.itemsEmp.length;
              });
            });
          } catch (updateError) {
            console.error("Error updating leave request:", updateError);
            await this.$swal({
              title: "Error",
              text: "An error occurred while updating the leave request.",
              icon: "error",
              customClass: {
                confirmButton: "btn btn-danger",
              },
            });
          }
          loader.close();
        }
      } catch (error) {
        console.error("Error fetching leave request:", error);
        await this.$swal({
          title: "Error",
          text: "An error occurred while fetching the leave request data.",
          icon: "error",
          customClass: {
            confirmButton: "btn btn-danger",
          },
        });
      }
    },

    success() {
      this.$swal({
        title: "Leave Request Cancelled!",
        text: "You have successfully cancelled the Leave Request!",
        icon: "success",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },

    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    exportToExcel() {
      if (!this.employee_items || this.employee_items.length === 0) {
        this.$bvToast.toast("No data available for export!", {
          title: "Export Failed",
          variant: "danger",
          autoHideDelay: 3000,
          solid: true,
        });
        return;
      }

      try {
        // Define CSV headers
        const headers = [
          "Employee Name",
          "Leave Type",
          "Start Date",
          "End Date",
          "Duration",
          "Notes",
          "Manager",
          "Days",
          "Approved Date",
          "Status",
        ].join(",");

        // Extract data rows
        const rows = this.employee_items.map((item) =>
          [
            `"${this.getEmployee(item.employeeId)}"`,
            `"${this.getLeaveType(item.leaveTypeID)}"`,
            `"${this.formatDate(item.startDate)}"`,
            `"${this.formatDate(item.returnDate)}"`,
            `"${item.leaveDurationType}"`,
            `"${item.notes}"`,
            `"${this.getEmployee(item.managerId)}"`,
            `"${item.days}"`,
            `"${this.formatDate(item.approvedDate)}"`,
            `"${item.status}"`,
          ].join(",")
        );

        // Combine headers and rows
        const csvContent = [headers, ...rows].join("\n");

        // Create a Blob and trigger download
        const blob = new Blob([csvContent], {
          type: "text/csv;charset=utf-8;",
        });
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute(
          "download",
          `LeaveRequests_${new Date().toISOString().slice(0, 10)}.csv`
        );
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // Show success toast
        this.$bvToast.toast("Leave Requests exported successfully!", {
          title: "Export Successful",
          variant: "success",
          autoHideDelay: 3000,
          solid: true,
        });
      } catch (error) {
        console.error("Error exporting CSV:", error);
        this.$bvToast.toast(
          "An error occurred while exporting. Please try again.",
          {
            title: "Export Error",
            variant: "danger",
            autoHideDelay: 3000,
            solid: true,
          }
        );
      }
    },
  },
  async mounted() {
    this.my_fields = IsAdmin()
      ? [
          { key: "leaveTypeID", label: "Leave Type", sortable: true },
          { key: "startDate", label: "Start Date", sortable: true },
          { key: "returnDate", label: "End Date", sortable: true },
          {
            key: "leaveDurationType",
            label: "Leave Duration Type",
            sortable: true,
          },
          { key: "notes", label: "Notes", sortable: true },
          {
            key: "managerId",
            label: "Approving Manager",
            sortable: true,
          },
          { key: "days", label: "Days", sortable: true },
          { key: "approvedDate", label: "Date Approved", sortable: true },
          { key: "status", label: "Status", sortable: true },
          { key: "actions", label: "Actions" },
        ]
      : [
          { key: "leaveTypeID", label: "Leave Type", sortable: true },
          { key: "startDate", label: "Start Date", sortable: true },
          { key: "returnDate", label: "End Date", sortable: true },
          {
            key: "leaveDurationType",
            label: "Leave Duration Type",
            sortable: true,
          },
          { key: "notes", label: "Notes", sortable: true },
          {
            key: "managerId",
            label: "Approving Manager",
            sortable: true,
          },
          { key: "days", label: "Days", sortable: true },
          { key: "approvedDate", label: "Date Approved", sortable: true },
          { key: "status", label: "Status", sortable: true },
          { key: "actions", label: "Actions" },
        ];

    await this.getLeaveRequestEmployeeAction().then(() => {
      this.totalRows = this.employee_items.length;
    });

    await this.getLeaveTypeListAction();

    await this.getEmployeeListAction().then(() => {
      this.employeeOptions = this.employeeList.map((employee) => ({
        value: employee.id,
        text: `${employee.firstName} ${employee.lastName}`,
      }));
    });

    if (IsAdmin()) {
      await this.getLeaveRequestListAction().then(() => {
        this.itemsEmp = this.leaverequests;
        this.totalRows1 = this.itemsEmp.length;
      });
    } else {
      await this.getLeaveRequestSubordinatesAction().then(() => {
        this.itemsEmp = this.subordinates_items;
        this.totalRows1 = this.itemsEmp.length;
      });
    }

    // await this.getLeaveRequestSubordinatesAction()
    //   .then(() => {
    //     this.totalRows1 = this.subordinates_items.length;
    //   });

    const userData = JSON.parse(localStorage.getItem("userData"));
    this.selectedEmployeeId = this.employeeList.filter(
      (x) => x.refId == userData.id
    )[0].id;
  },
  setup() {
    return {
      IsAdmin,
    };
  },
};
</script>
